var UserAdmin = function(options){
    this.settings = $.extend({}, this.defaults, options);
    this.init();
};

UserAdmin.prototype = {

    // shorthand for using prototype
    constructor : UserAdmin,

    // default options
    defaults : {

    },
    selectedDonors: [],
    bulkSelectValue: false,
    init : function(){
        var _this = this;

        // init past donor table event listeners
        if ($(".past-donor-table").length) {
            _this.pastDonorGroupEdit();
            _this.handleBulkSelect();
            _this.handlePastDonorTableSorting();
        }

        if ( $('.ua-page-container').length ) {
            $('html').addClass('ua-layout');
        }

        /* ======================================================
        = Global Event Handlers / Inits
        ====================================================== */
        // Chosen dropdowns
        if ( $.fn.chosen ){
            $('.chosen-select-full').chosen({
                disable_search: true,
                width: "100%"
            });

            $('.chosen-select-auto').chosen({
                disable_search: true,
                width: "auto"
            });

            $('.chosen-select-state, .chosen-select-country, .chosen-select.state_select, .chosen-select.country_select, .chosen-select.js-specific-donation').chosen({
                enable_split_word_search: false,
                width: '100%'
            });

            $('.chosen-select').each(function(){
                $(this).chosen({
                    disable_search_threshold: 10,
                    width: "100%"
                });

                // add ARIA attribute for improved, but not perfect screen reader accessibility
                var ariaLabel = $(this).attr('aria-label');

                if ( ariaLabel ) {
                    $(this).next('.chosen-container').attr('aria-label', ariaLabel).find('.chosen-search input').attr('aria-label', ariaLabel);
                }
            });
        }

        _this.loadingModal = $('#loading-modal').modal({
            bgClose : false,
            disableTrigger : true
        });

        // country selector init
        if ( $.fn.countrySelector && $('.has-country-selector').length ) {
            $('.has-country-selector').countrySelector( { 'zipRequired' : false } );
        }

        // country selector init
        if ( $.fn.customImage ) {
            _this.setupAvatarUpload();
        }

        // Datepicker Init
        if ( $('.datepicker').length && $.fn.Zebra_DatePicker ) {
            $('.datepicker').Zebra_DatePicker({
                format: 'm/d/Y',
                show_icon : false,
                show_select_today : false,
                show_clear_date : false,
                readonly_element : false,
                onSelect: function(formattedDate, standardDate, jsDate, $datepicker) {
                    $datepicker.trigger('change');
                }
            });
        }

        // Fundraising totals grid
        if ( ($('.content-beta').length || $('.content-gamma').length) && fitty ) {
            fitty('.js-thermometer-stat-value', {
                maxSize : 42
            });
        }

        // Generic Scroll
        if ($('.scroll-trigger').length ) {
            $('.scroll-trigger').on('click', function(e) {
                e.preventDefault();
                UI.scrollToElement($(this).attr('href'), 600, undefined, 60);
            });
        }

        // URL alias input validation
        $('#donation_url, #team_url, #participant_shortcode, #team_shortcode, #classification_shortcode').on('keyup', function() {
            var value = $(this).val();

            // covers pasted text
            // making sure we have a symbol before we try to replace or we render arrow navigation useless
            if (/[^0-9a-zA-Z-_]/.test(value) ) {
                $(this).val($(this).val().replace(/[^0-9a-zA-Z-_]/g, '').toLowerCase());
            }
        });

        $('.ua-tools-toggle').on('click', function(e){
            e.preventDefault();

            UI.toggleStatus('active', '#ua-panel-body');
        });

        $('.page-layout-alternate .main-nav-toggle').on('click', function(e) {
            e.preventDefault();
            $(this).toggleClass('active');
            UI.toggleStatus('active', '.main-navigation');
            UI.toggleStatus('main-nav-active', '#ua-panel-body');
        });

        // update thermometer goal
        $('.trigger-update-goal').on('click', function(e){

            var asset = {},
                scripts = [],
                callbacks = [];

            scripts.push({
                'id' : 'autonumeric',
                'path' : '/resources/dist/scripts/vendor/autonumeric/autoNumeric.min.js'
            });

            callbacks.push(function(){
                AutoNumericNumber('#update-goal-amount');
            });

            asset.scripts = scripts;
            asset.callbacks = callbacks;

            AssetManager.load({0 : asset});

            e.preventDefault();
        });

        /*
        * Controls UI for a "Create/Add New" buttons that reveal / scroll to a form with a cancel button to collapse
        * (Team Fundraising Page, My Donations, Badge Center, etc.)
        */
        if($('.add-new-toggle').length) {
            $('.add-new-toggle').on('click', function() {
                var target = $(this).attr('href')
                    $formFields = $(target).find(':input');

                // hide the add matching gift form if it's visible
                if (!$('.js-add-matching-gift').hasClass('hide-content')) {
                    $('.js-add-matching-gift').addClass('hide-content');
                }

                // Clear donation ID field when adding a new donation
                $('input[name="donationId"]').val('');

                // Empty out the form / prior errors before doing anything
                $(target).find('.ui-message').remove().end()
                    .find('#offline-amount').text( currencyFormat('0') ).end()
                    .find('#check').trigger('click');

                //show custom fields and thank you email section when adding donation
                $('.custom-fields').removeClass('hide-content');
                $('.email-thanks-content').removeClass('hide-content');

                // change the text for the save button
                $('.save-donation').val("Save Donation");

                var target = $(this).attr('href') || $(this).attr('data-content-toggle');
                //if you click the add button when the form is already visible, scroll back to it
                if(!$(target).hasClass('hide-content') && $(this).hasClass('show-form')) {
                    UI.scrollToElement( $(target), 600, undefined, 60 );
                } else {
                    //otherwise close the form
                    UI.toggleContent($(this));
                }

                //if the form was just revealed, scroll down
                if(!$(target).hasClass('hide-content')){
                    //scroll down to the form...
                    UI.scrollToElement( $(target), 600, undefined, 60 );
                }
                return false;
            });
        }

        // "Check" or "Cash" Toggle for donation forms
        if ($('#add-donations input[name="type"]').length) {
            $('#add-donations input[name="type"]').on('change', function() {
                var target = $(this).attr('data-content-toggle'),
                    $amtField = $(target).find('.donation-amount'),
                    $selectedInput = $('#add-donations input[name="type"]:checked');

                if ( $selectedInput.val().toLowerCase() != 'check' ){

                    $(target).addClass('hide-content');
                    $amtField.removeClass('validateEmpty');

                    if( $amtField.hasClass('has-error') ){
                        UI.clearErrors($amtField);
                    }

                } else {
                    $(target).removeClass('hide-content');
                    $amtField.addClass('validateEmpty');
                    UI.focusOnLoad();
                }
            });
        }

        // init AutoNumeric for matching gift amount
        if ( $('#matching-amount').length ) AutoNumericNumber('#matching-amount');

        /**
        * @function updateMatching
        * @param {string} [donationID] ID of the donation to match
        * @param {string} [amountToMatch] Amount of the donation to match
        * @param {bool} [showSpecificDonation] If true the `js-specific-donation-container` will be shown, otherwise it will be hidden
        * @description Hides/shows elements and updates data attributes for matching donations form on fundraising dashboard
        */
        function updateMatching ( donationID, amountToMatch, showSpecificDonation ) {
            var $addMatchingGift = $( '.js-add-matching-gift' );
            var $matchingAmount = $addMatchingGift.find('.js-matching-amount');
            var $specificDonationContainer = $addMatchingGift.find('.js-specific-donation-container');

            $addMatchingGift.find( '.js-add-matching-gift-form' ).validate();

            // show the matching gift form
            $addMatchingGift.removeClass( 'hide-content' );

            // show/hide the specific donation stuff
            if ( showSpecificDonation ){
                $specificDonationContainer.removeClass( 'hide-content' );
            } else {
                $specificDonationContainer.addClass( 'hide-content' );
            }

            // hide the add donation form if it's visible
            $( '.js-add-donation' ).addClass( 'hide-content' );

            //if the form was just revealed, scroll down
            if ( ! $addMatchingGift.hasClass( 'hide-content' ) ) {
                UI.scrollToElement( '.js-add-matching-gift', 600, undefined, 60 );
            }

            // update donation id for the add matching gift forms
            $addMatchingGift.find( '.js-donation-to-match' ).val( donationID );

            // copy donation amount for comparison
            if ( typeof amountToMatch === 'undefined' ) {
                $matchingAmount
                    .removeClass( 'validateMaxAmount' )
                    .attr( 'data-max-amount', 0 );
            } else {
                $matchingAmount
                    .addClass( 'validateMaxAmount' )
                    .attr( 'data-max-amount', amountToMatch );
            }

            if ( $matchingAmount.val().length ) {
                $matchingAmount.trigger( 'blur' );
            }
        }

        /**
        * @function handleSpecificDonationChange
        * @description Gathers donationID and amountToMatch when `js-specific-donation` or `js-link-to-specific-donation` element is changed
        */
        function handleSpecificDonationChange () {
            var $specificDonation = $( '.js-specific-donation' );
            var donationID = $specificDonation.val();
            var amountToMatch = $specificDonation.find( ':selected' ).attr('data-donation-amount');

            updateMatching( donationID, amountToMatch, true );
        }

        // show add matching gift form
        $('.js-toggle-add-matching-gift').on('click', function() {
            var donationID = $(this).attr('data-donation-id');
            var amountToMatch = $(this).attr('data-donation-amount');
            var showSpecificDonation = typeof donationID === 'undefined'

            updateMatching( donationID, amountToMatch, showSpecificDonation );
        });

        $( '.js-specific-donation' ).on( 'change', function () {
            handleSpecificDonationChange();
        } );

        $( '.js-link-to-specific-donation' ).on( 'change', function () {
            if ( $( this ).is( ':not(:checked)' ) ) {
                updateMatching( undefined, undefined, true );
            } else {
                handleSpecificDonationChange();
            }
        } );

        // cancel adding a matching gift
        $('.js-cancel-matching-gift').on('click', function() {
            // reset form values
            $('.js-matching-name').val('');
            $('.js-matching-amount').val('');

            // hide form and scroll back to the donations list
            $('.js-add-matching-gift').addClass('hide-content');

            UI.scrollToElement( $('.js-donation-section'), 600, undefined, 60 );
        });

        /* ======================================================
        = Sharing / Email Management Screens
        ====================================================== */

        // Schedult Post UI (Facebook, Twitter, Email Mgmt, Custom Badges)
        if ($('input[name*="post-type"]').length) {
            $('input[name*="post-type"]').on('change', function() {
                var selected = $('input[name*="post-type"]:checked');
                $(selected).closest('.ui-option').addClass('is-selected').siblings().removeClass('is-selected');
            });
        }

        // create event listener which checks which tab is active and then reveals the
        // appropriate section
        $(".past-campaign-tab, .current-campaign-tab").on("click", function () {
            const $matchingGiftUI = $("#matching-gift-new");
            const $offlineDonationUI = $("#add-donation");
            if ($(this).hasClass("past-campaign-tab")) {
                $("#donation-section").addClass("hide-content");
                $("#past-campaigns-section").removeClass("hide-content");

                // hide any current campaign related UI
                if (!$matchingGiftUI.hasClass("hide-content")) {
                    $matchingGiftUI.addClass("hide-content");
                }
                if (!$offlineDonationUI.hasClass("hide-content")) {
                    $offlineDonationUI.addClass("hide-content");
                }
            }

            if ($(this).hasClass("current-campaign-tab")) {
                $("#past-campaigns-section").addClass("hide-content");
                $("#donation-section").removeClass("hide-content");
            }
        });

        UI.postPreviews.init();

        /* ======================================================
        = Fundraising Dashboard for Participants
        ====================================================== */
        // bind modal for text giving wizard
        $('.js-text-giving-modal').modal({
            bgClose: true,
            width: 'width-60',
            onShow : function(){
                $('.message-input').find('p').delay(2000).queue(function(next){
                    $(this).removeClass('is-hidden').addClass('typing');
                    next();
                    $('.typing').one('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd', function() {
                        $(this).addClass('is-hidden');
                        $('.message.sender').addClass('fade-in');
                        $('.message.recipient').addClass('fade-in delayed');
                    });
                });
            }
        });

        // show form to create shortcodes if they are empty
        $(".js-toggle-create-shortcodes").on("click", () => {
            const textGivingHowToView = $("#js-text-giving-how-to");
            const textGivingEditView = $("#js-text-giving-edit");

            $(textGivingEditView).removeClass("hide-content");
            $(textGivingHowToView).addClass("hide-content");
        });

        // refresh dashboard after saving shortcodes in the wizard
        $('.js-refresh-dashboard').on('click', function() {
            window.location.hash = '#my-shortcodes';
            window.location.reload(true);
        });

        // show texting tab after creating shortcodes in the wizard
        if(window.location.hash == '#my-shortcodes') {
            $('document').ready(function() {
                UI.toggleTabbedContent($('a[href="' + window.location.hash + '"]'));
            });
        }

        /* ======================================================
        = Page Specific - Team Fundraising
        ====================================================== */
        // Custom URL input
        if($('.input-wrap input').length){
            $.fn.textWidth = function() {
                var target = this.attr('data-text-target'),
                    fontSize = parseInt($('body').css('fontSize')) * 0.925;

                $(target).text(this.val() || this.text()).css('font', 'normal normal normal ' + fontSize + 'px/normal sans-serif');
                return $(target).width();
            };

            var setupTextNodes = function(target, selector, i) { //used by textWidth
                $('<span class="'+ selector + '-' + i +'">').hide().appendTo(document.body);
                target.attr('data-text-target', '.' + selector + '-' + i);
            }

            var calcPercent = function(target, context) { //helper
                var t = Math.floor(target),
                    c = Math.floor(context);
                return t / c * 100 + '%';
            }

            const updateCopyButton = function (target) {
                const parent = target.closest(".field-container");
                const prefix = parent.find(".prefix");
                const fullUrl = parent.find(".full-url");
                const savedKeywordDisplay = parent.find(
                    ".saved-keyword-display",
                );
                const campaignKeyword = parent.find(".campaign-keyword");
                const copyButton = parent.find(".copy-button");

                if (prefix?.length) {
                    copyButton.attr(
                        "data-clipboard-text",
                        prefix.text() + target.val(),
                    );
                } else if (fullUrl?.length) {
                    copyButton.attr("data-clipboard-text", fullUrl.text());
                } else if (savedKeywordDisplay?.length) {
                    copyButton.attr(
                        "data-clipboard-text",
                        `${campaignKeyword.text()} ${savedKeywordDisplay.text()}`,
                    );
                }
            };

            const updateVisitButton = function (target) {
                const parent = target.closest(".field-container");
                const prefix = parent.find(".prefix");
                const fullUrl = parent.find(".full-url");
                const savedKeywordDisplay = parent.find(
                    ".saved-keyword-display",
                );
                const campaignKeyword = parent.find(".campaign-keyword");
                const visitButton = parent.find(".visit-button");

                if (prefix?.length) {
                    visitButton.attr(
                        "href",
                        prefix.text() + target.val(),
                    );
                } else if (fullUrl?.length) {
                    visitButton.attr("href", fullUrl.text());
                } else if (savedKeywordDisplay?.length) {
                    visitButton.attr(
                        "href",
                        `${campaignKeyword.text()} ${savedKeywordDisplay.text()}`,
                    );
                }
            };

            const moveCursorToEndOfInput = (element) => {
                if (typeof element.selectionStart == "number") {
                    element.selectionStart = element.selectionEnd = element.value.length;
                } else if (typeof element.createTextRange != "undefined") {
                    element.focus();
                    const range = element.createTextRange();
                    range.collapse(false);
                    range.select();
                }
            }

            var updateCopyButtonVisibility = function(target) {
                var parent = target.closest('.field-container'),
                    prefix = parent.find('.prefix'),
                    copyButton = parent.find('.copy-button');

                copyButton.removeClass('is-hidden');
            }

            var resizeInput = function(target) { //init / on edit / screen resize
                var parent = target.closest('.faux-input-wrapper'),
                    inputContainer = parent.find('.input-wrap'),
                    inputField = inputContainer.find('input'),
                    prefixContainer = parent.find('.prefix-wrap'),
                    prefix = parent.find('.prefix');

                if(prefix.textWidth() + inputField.textWidth() < parent.width()) {
                    //if there's enough space for both, show the full prefix and let the input take up the rest
                    inputContainer.width('auto');
                    prefixContainer.width(calcPercent(prefix.textWidth(), parent.width()));
                } else {
                    //if not, fit the input field and shorten the prefix
                    prefixContainer.width('auto');
                    inputContainer.width(calcPercent(inputField.textWidth(), parent.width()));
                }
            }

            //set up the empty text nodes so we can measure their sizes
            $('.prefix').each(function(i) {
                setupTextNodes($(this), 'prefix', [i]);
            });

            $('.input-wrap input').each(function(i) {
                setupTextNodes($(this), 'input', [i]);
                updateCopyButton($(this));
                resizeInput($(this));
            });

            $(".field-container .cancel-button").on("click", function () {
                let parent = $(this).closest(".field-container");
                parent.toggleClass("non-editable editable");
            });

            //edit / save toggle
            $('.field-container .edit-button, .field-container .save-button').on('click', function() {
                var parent = $(this).closest('.field-container'),
                    inputField = parent.find('.input-wrap input');
        

                let inputValue = inputField.val();

                moveCursorToEndOfInput(inputField[0]);

                if (
                    inputField.attr("id") == "donation_url" ||
                    inputField.attr("id") == "team_url"
                ) {
                    if (inputField.val().length < 1) {
                        $(".full-url-dash").addClass("hide-content");
                        inputValue = `${inputField.val()}`; 
                    } else {
                        $(".full-url-dash").removeClass("hide-content"); 
                        inputValue = `-${inputField.val()}`;
                    }
                    Message.scrollToMessage = false;
                }

                // Prevent saving an empty keyword value
                if (
                    (inputField.attr("id") == "participant_shortcode" ||
                        inputField.attr("id") == "team_shortcode" ||
                        inputField.attr("id") == "classification_shortcode") &&
                    !inputValue
                ) {
                    parent.find(".input-wrap input").addClass("error");
                    setTimeout(() => {
                        parent.find(".input-wrap input").removeClass("error");
                    }, 4000);
                    Message.target = "#my-shortcodes";
                    Message.post(
                        "Text keyword cannot be blank. Please save a unique keyword!",
                        "error",
                    );
                    // if not in the text giving modal we want the success message to fade out
                    $(".ui-message").fadeIn().delay(4000).fadeOut();
                    return;
                }
             
           
                //toggle edit state
                parent.toggleClass('non-editable editable');
                if(parent.hasClass('editable')) {
                    if (inputField.val().length < 1 && $(this).closest("#my-urls").length>0) {
                        var t = inputField.closest('.faux-input').find('.prefix').text();
                        inputField.closest('.faux-input').find('.prefix').text(t + "-");
                    }

                    inputField
                        .closest(".input-wrap")
                        .removeClass("hide-content");

                    parent.find(".keyword-input").removeClass("hide-content");

                    //remove any widths applied
                    parent.find('.faux-cell').removeAttr('style');

                    //activate the input
                    inputField.prop('readonly', false).focus();

                } else {
                    if (inputField.val().length < 1) {
                        var t = inputField.closest('.faux-input').find('.prefix').text().replace('-', '');
                        inputField.closest('.faux-input').find('.prefix').text(t);

                        console.log({t, inputValueLength: inputField.val().length })
                    }

                    parent.find(".saved-keyword-display").text(inputValue);

                    parent
                        .find(".saved-keyword-display")
                        .removeClass("hide-content");

                    parent.find(".keyword-input").addClass("hide-content");
                
                    // make ajax call to save alias
                    _this.saveAlias(inputField, function() {
                        resizeInput(inputField);
                        inputField.prop('readonly', true);
                    });
                }

                // update copy button
                updateCopyButton( inputField );
                updateVisitButton( inputField );

                if (inputField.val().length > 0) {
                    updateCopyButtonVisibility(inputField);
                }
            });

            $(window).resize(function() {
                $('.input-wrap input').each(function(i) {
                    resizeInput($(this));
                });
            });

            //when you edit the input, we need to update the copy URL value too
            $('.input-wrap input').on('input', function() {
                updateCopyButton($(this));
            });
        }

        // bind the button to save subregistrant information
        $('.save-subregistrant').on('click', function(e) {
            e.preventDefault();
            _this.saveSubregistrantInfo($(this));
        });

        // update the fundraising goal
        $('.update-goal').on('click', function(e) {
            e.preventDefault();
            _this.updateGoal();
        });

        // init AutoNumeric for Recruitment Goal Amount
        if ( $('#update-recruitment-goal-amount').length ) AutoNumericNumber('#update-recruitment-goal-amount');

        // update the recruitment goal
        $('.js-update-recruitment-goal').on('click', function(e) {
            _this.updateRecruitmentGoal();
            e.preventDefault();
        });

        // truncate badge descriptions
        UI.truncate( '.badge-popup-description', 75 );

        // email donors modal
        $('.js-email-donor-modal').modal({
            bgClose: false,
            width : 'width-800-hard',
            onShow: function() {
                // prevent scrolling due to ckeditor combobox scrolling bug
                $('html').addClass('prevent-scrolling');

                // Add 'Insert' dropdown if there's a table
                var ckToolbar = UI.ckeditor.full;
                if ( $('.insert-tags-table').length ) {
                    // Place button at the beginning of the last row (3 elements back)
                    ckToolbar.splice(-3, 0, ['strinsert'] );
                }

                // Init Editor
                $('.ck-instance').each(function() {
                    if (!CKEDITOR.instances[$(this).attr('data-ckId')]) {
                        CKEDITOR.replace( $(this).attr('data-ckId'), {
                            toolbar: ckToolbar,
                            height: ['150px'],
                            removePlugins : 'wsc',
                        });
                    }

                    if ($(this).val().length) {
                        CKEDITOR.instances[$(this).attr('data-ckId')].setData($(this).text());
                    }
                });
            },
            onClose: function() {
                $('html').removeClass('prevent-scrolling');
            }
        });

        // transfer donation ID to modal and display donor name
        $('.js-email-donor-modal').on('click', function(e) {
            var emailDonorModal = $('#email-donor-modal'),
                donorName = $(this).attr('data-donor-name');

            e.preventDefault();
            emailDonorModal.attr('data-donation-id', $(this).attr('data-donation-id'));
            emailDonorModal.find('.heading-beta').text("Contact " + donorName);
        });
    },

    updateGoal: function() {
        var _this = this;

        // decide if we need to update a team or an account goal
        if ( $('input[name="classification"]').length > 0 ){
            var ajaxUrl = url('classification_fundraising', [$('input[name="classification"]').val()]);
        } else if ($('input[name="team"]').length > 0) {
            var ajaxUrl = url('team_fundraising', [$('input[name="team"]').val()]);
        } else {
            var ajaxUrl = url('pfp_dashboard', [$('input[name="registration"]').val()]);
        }

        var postString = 'updateGoal=1&goal='+encodeURIComponent($('#update-goal-amount').val());

        $.fn.qpost({
            url : ajaxUrl,
            csrf : true,
            data : postString,
            success : function(data) {
                if (data.success) {
                    window.location.reload(true);
                } else {
                    Message.target = '.thermometer-form';
                    Message.post(data.errors,  'error');
                }
            },
            failure : function() {
                Message.target = '.thermometer-form';
                Message.post('We were unable to update your goal. Please try later',  'error');
            },
        });
    },

    updateRecruitmentGoal : function() {
        var _this = this,
            ajaxUrl = url('team_fundraising', [$('input[name="team"]').val()]),
            postString = 'updateRecruitmentGoal=1&goal='+encodeURIComponent($('#update-recruitment-goal-amount').val());

        $.fn.qpost({
            url : ajaxUrl,
            csrf : true,
            data : postString,
            success : function(data) {
                if (data.success) {
                    window.location.reload(true);
                } else {
                    Message.target = '.recruitment-goal-form';
                    Message.post(data.errors,  'error');
                }
            },
            failure : function() {
                Message.target = '.recruitment-goal-form';
                Message.post('We were unable to update your goal. Please try later',  'error');
            },
        });
    },

    saveAlias: function(inputField, callback) {
        var _this = this;
        var registration = inputField.attr('data-id');
        inputField.val(inputField.val().replace(/ /g,''));
        var postString = 'alias='+inputField.val();
        var saveSuccessMessage = `Your shortcode "${inputField.val()}" has been saved!`;
        var deleteSuccessMessage = 'Your shortcode has successfully been removed!';
        var onFailureMessage = 'We were unable to edit your shortcode. Please try later';

        if (inputField.attr('id') == "donation_url") {
            postString += "&type=registration";
        } else if (inputField.attr('id') == "team_url") {
            postString += "&type=team";
        } else if (inputField.attr('id') == "participant_shortcode") {
            postString += "&type=registrationSMS&smsid=" + inputField.attr('data-sms-id');
        } else if (inputField.attr('id') == "team_shortcode") {
            postString += "&type=teamSMS&smsid=" + inputField.attr('data-sms-id');
        } else if (inputField.attr('id') == "classification_shortcode") {
            postString += "&type=classificationSMS&smsid=" + inputField.attr('data-sms-id');
        }

        var url = '/event/account/'+registration+'/manage';
        // checks to see if the text giving modal is currently visible. returns boolean
        var textGivingModalActive = $('.text-giving-wizard-modal').closest('.ui-modal-container').attr('aria-hidden') === 'false';

        $.fn.qpost({
            url : url,
            csrf : true,
            data : postString,
            success : function(data) {
                Message.reset();
                if (data.success && data.status !== 'deleted') {
                    if(textGivingModalActive) {
                        Message.target = '.ui-modal-message';
                        Message.post(saveSuccessMessage, 'success');
                    } else {
                        Message.target = '#my-shortcodes';
                        Message.post(saveSuccessMessage, 'success');
                        // if not in the text giving modal we want the success message to fade out
                        $('.ui-message').fadeIn().delay(4000).fadeOut();
                    }
                    if (callback && typeof callback == 'function') {
                        callback();
                    }
                    if (data.status == 'inserted') {
                        inputField.attr('data-sms-id', data.success);
                    } else if (data.status == 'deleted') {
                        inputField.attr('data-sms-id', 0);
                    }
                } else if (data.status === 'deleted') {
                    Message.reset();
                    if(textGivingModalActive) {
                        Message.target = '.ui-modal-message';
                        Message.post(deleteSuccessMessage, 'success');
                    } else {
                        Message.target = '#my-shortcodes';
                        Message.post(deleteSuccessMessage, 'success');
                        $('.ui-message').fadeIn().delay(4000).fadeOut();
                    }
                    Message.scrollToMessage = false;
                    // Need to set data-sms-id to undefined as to avoid the back end registering proceeding requests as a blank insertion
                    inputField.attr('data-sms-id', '');
                } else if (data.errors) {
                    Message.reset();
                    if(textGivingModalActive) {
                        Message.target = '.ui-modal-message';
                    } else {
                        Message.target = '#my-shortcodes';
                    }
                    Message.scrollToMessage = false;
                    Message.post(data.errors, 'error');
                }
            },
            failure : function() {
                if(textGivingModalActive) {
                    Message.target = '.ui-modal-message';
                    Message.post(onFailureMessage, 'error');
                } else {
                    Message.target = '#my-shortcodes';
                    Message.post(onFailureMessage, 'error');
                    $('.ui-message').fadeIn().delay(4000).fadeOut();
                }
            },
        });
    },

    saveSubregistrantInfo: function(element) {
        var _this = this;
        var registration = $('input[name="registrationId"]').val();
        var registrantForm = 'registration-'+element.data('registrant');
        var postString = 'type=editSub'+buildPostString($('#'+registrantForm));
        var url = '/event/account/'+registration+'/manage';

        $.fn.qpost({
            url : url,
            csrf : true,
            data : postString,
            success : function(data) {
                if (data.success) {
                    window.location.reload(true);
                } else {
                    _this.displayErrorMesage(data.errors, registrantForm);
                }
            },
            failure : function() {
                _this.displayErrorMesage('We were unable to edit sub-registrant. Please try later', registrantForm);
            },
        });
    },

    displayErrorMesage: function(message, form) {
        Message.target = '.' + form;
        Message.setMessage(message);
        Message.type = 'error';
        Message.postMessage();
    },

    setupAvatarUpload : function() {
        var _this = this;

        $('.avatar-upload').each(function() {
            var _type = $(this).hasClass('participant-avatar') ? 'participant-avatar' : 'team-avatar';

            if ( _type == 'participant-avatar' ) {
                var actionUrl = url('pfp_upload', [$('#registration-id').val()]);
            } else if ( _type == 'team-avatar' ) {
                var actionUrl = url('tfp_upload', [$('#team-id').val()]);
            }

            // init avatar image manager
            $(this).find('#avatar-upload').customImage({
                action : actionUrl,
                cropWidth : 175,
                cropHeight : 175,
                allowedExtensions : ['jpg', 'jpeg', 'pjpeg', 'png'],
                onComplete : function(image, container, id, fileName, path, response){
                    image.attr('src', response.url);
                    container.addClass('image-edit-enabled');
                    $('.event-content .avatar-message').remove();
                },
                onCropComplete : function(image, container){
                    image.wrap('<div class="avatar-cropped" />');
                    container.removeClass('image-edit-enabled');
                    _this.saveAvatar( _type );
                },
                onCropCancel : function(image, container, defaultImage){
                    container.removeClass('image-edit-enabled');
                },
                onValidationError : function(id, filename, message){
                    Message.target = '.event-content:first';
                    Message.scrollToMessage = false,
                    Message.post(message, 'error avatar-message');
                }
            });
        });

        // description text for avatar actions
        $('.avatar-icon').hover(function(){
            var title = $(this).attr('title');

            $(this).siblings('.action-description').text(title);
        }, function(){
            $(this).siblings('.action-description').text('');
        });

        // trigger avatar delete
        $('.trigger-avatar-delete').on('click', function(e){
            var $container = $(this).closest('.ui-custom-image-container'),
                defaultImage = $container.attr('data-default-image');

            var _type = $(this).closest('.avatar').hasClass('participant-avatar') ? 'participant-avatar' : 'team-avatar';

            if ( defaultImage.length > 0 ){
                $container.find('.ui-custom-image-placeholder').removeClass('hide-content').removeAttr('style').attr('src', defaultImage);
            } else {
                $container.find('.ui-custom-image-default-placeholder').removeClass('hide-content');
                $container.find('.ui-custom-image-placeholder').addClass('hide-content');
            }

            $container.find('.ui-custom-image').addClass('hide-content').removeAttr('style');

            $container.next('.reset-avatar').val('1');

            _this.saveAvatar( _type );

            e.preventDefault();
        });
    },

    storeSelectedDonors: function() {
        const _this = this;
        const $pastDonorTable = $(".past-donor-table");
        // adds donors to array for reselection after sort
        $pastDonorTable
            .find(".data-row.selected")
            .each((index, row) =>
                _this.selectedDonors.push($(row).attr("data-email")),
            );
    },

    handleBulkSelect: function () {
        const _this = this;
        $(".select-deselect-all, .checkbox-select").on("click change", function () {
            const $emailPastDonorButton = $(".email-past-donor-button");
            const $pastDonorTable = $(".past-donor-table");
            const isDisabled =
                $pastDonorTable.find(".checkbox-select:checked").length === 0;
            // if email is not verified we return early
            // so that email past donor button remains disabled
            const isEmailVerified = $("#isEmailVerified").val() === "1";
            if (!isEmailVerified) {
                return;
            }
            // clear existing selected donors
            _this.selectedDonors = [];
            // update selected donors
            _this.storeSelectedDonors();

            // handle single checkbox uncheck logic
            if($(this).hasClass("checkbox-select") && $(this).prop("checked") === false) {
                const email = $(this).attr("data-email");
                const selectionIndex = _this.selectedDonors.indexOf(email);
                _this.selectedDonors.splice(selectionIndex, 1);
            }

            // Handle select all
            if (
                $(this).hasClass("select-deselect-all") &&
                $(this).prop("checked")
            ) {
                $(".checkbox-select").prop("checked", true);
                $(".data-row").addClass("selected");
                _this.bulkSelectValue = true;
                _this.storeSelectedDonors();
            }

            // unselect all donors
            if (
                $(this).hasClass("select-deselect-all") &&
                $(this).prop("checked") === false
            ) {
                $(".checkbox-select").prop("checked", false);
                _this.selectedDonors = [];
                $(".past-donor-table")
                    .find(".data-row.selected")
                    .removeClass("selected");
                _this.bulkSelectValue = false;
            }

            // Enable / Disable Email Past Donor Button
            if (isDisabled) {
                $($emailPastDonorButton).addClass("appearance-disabled");
                $($emailPastDonorButton).prop("disabled", true);
            } else {
                $($emailPastDonorButton).removeClass("appearance-disabled");
                $($emailPastDonorButton).prop("disabled", false);
            }
        });
    },

    pastDonorGroupEdit: function () {
        $(".past-donor-table").groupEdit({
            keepActivatedOnApply: true,
            onApply: function (table, selected) {
                // iterate through selected rows adding emails to array
                const emails = [];
                selected.each(function (index, checkbox) {
                    if ($(checkbox).prop("checked") === true) {
                        emails.push($(checkbox).attr("data-email"));
                    }
                });
                // assemble post string using the comma separated
                // emails as a parameter
                const emailString = emails.join(",");
                let postString = "&mailing-list-addresses=" + emailString;
                postString += "&action=hidden-list";
                const id = $("#participant-id").val();
                const postUrl =
                    window.location.origin + "/event/account/" + id + "/email";

                // post request
                $.fn.qpost({
                    url: postUrl,
                    csrf: true,
                    data: postString,
                    success: function (data) {
                        if (data.success) {
                            // display loading spinner
                            $("#loading-modal .heading-delta").text("Loading");
                            _this.loadingModal.data("qg_modal").showModal();
                            // redirect to the email campaign page in Share My Page
                            const url =
                                window.location.origin +
                                "/event/account/" +
                                id +
                                "/campaign/?list=" +
                                data.mailingList;
                            window.location.replace(url);
                        } else {
                            Message.target = ".event-content:first";
                            Message.post(
                                "Oops! We were unable to retrieve past donors' emails. Please try again!",
                                "error",
                            );
                        }
                    },
                    failure: function () {
                        Message.target = ".event-content:first";
                        Message.post(
                            "Oops! We were unable to retrieve past donors' emails. Please try again!",
                            "error",
                        );
                    },
                });
            },
        });
    },
    handlePastDonorTableSorting: function () {
        const _this = this;
        $(document).one("click", ".sortable", function () {
            // sets sort style to descending (arrow down)
            if ($(".icon-sort", this).hasClass("sort-asc")) {
                $(this).attr("data-sort", "DESC");
                $(".icon-sort", this)
                    .removeClass("sort-asc")
                    .addClass("sort-desc");
            } else {
                // sets sort style to ascending (arrow up)
                $(this).attr("data-sort", "ASC");
                $(".icon-sort", this)
                    .removeClass("sort-desc")
                    .addClass("sort-asc");
            }
            // removes sort styling from other columns
            $(".sortable")
                .not(this)
                .attr("data-sort", "")
                .find(".icon-sort")
                .removeClass("sort-desc")
                .removeClass("sort-asc");

            // store currently selected donors so that we can
            // reselect after table reloads
            _this.storeSelectedDonors();

            // store current state of bulk select for 
            // reselection after table reloads
            if ($(".select-deselect-all").is(":checked")) {
                _this.bulkSelectValue = true;
            }
            // method which handles BE request
            _this.updatePastDonorTable();
        });
    },

    updatePastDonorTable: function () {
        const _this = this;
        const id = $("#participant-id").val();
        const drawTable = function (data) {
            if (data.success) {
                $(".past-donor-table").html(data.html);
                // call init to reinitialize table event listeners
                _this.init();
                // reselect selections prior to sorting
                if (_this.bulkSelectValue) {
                    $(".select-deselect-all").prop("checked", true);
                }
                _this.selectedDonors.forEach((selectedDonor) => {
                    $(`[data-email|='${selectedDonor}']`)
                        .addClass("selected")
                        .prop("checked", true);
                });
                _this.selectedDonors = [];
            }
            if (data.errors) {
                Message.target = ".event-content:first";
                Message.post(
                    "Unable to process sorting request, please try again",
                    "error",
                );
            }
        };

        let postString =
            "&sort_field=" +
            $(".sortable")
                .find(".sort-asc, .sort-desc")
                .parent()
                .attr("data-type");
        postString +=
            "&sort_order=" +
            $(".sortable")
                .find(".sort-asc, .sort-desc")
                .parent()
                .attr("data-sort");
        postString += "&action=sort-donors";

        const postUrl =
            window.location.origin + "/event/account/" + id + "/mydonations";

        return $.fn.qpost({
            url: postUrl,
            type: "POST",
            data: postString,
            dataType: "JSON",
            success: drawTable,
            failure: () => {
                Message.target = ".event-content:first";
                Message.post(
                    "Unable to process sorting request, please try again",
                    "error",
                );
            },
        });
    },

    saveAvatar : function( _type ) {
        var _this = this;

        if ( _type == 'participant-avatar' ) {
            var postString = buildPostString($('.manage-participant-avatar'));
            var actionUrl = url('manage_account', [$('#registration-id').val()]);

        } else if ( _type == 'team-avatar' ) {
            var postString = buildPostString($('.manage-team-avatar'));
            var actionUrl = url('team_fundraising', [$('#team-id').val()]);
        }

        $('#loading-modal .heading-delta').text('Saving Avatar');
        _this.loadingModal.data('qg_modal').showModal();

        $.fn.qpost({
            url : actionUrl,
            csrf : true,
            data : postString,
            dataType : 'json',
            success : function(data) {
                if (data.success) {
                    Message.target = '.event-content:first';
                    Message.post('Your avatar has been updated.', 'success');
                } else {
                    Message.target = '.event-content:first';
                    Message.post(data.errors, 'error');
                }

                if ( window.reloadOnAvatarSave ) {
                    window.location.reload(true);
                } else {
                    _this.loadingModal.data('qg_modal').closeModal();
                }
            },
            failure : function() {
                Message.target = '.event-content:first';
                Message.post('We were not able to save your settings. Please try again.', 'error');
                _this.loadingModal.data('qg_modal').closeModal();
            },
        });
    }

};

$(document).ready(function(){
    var useradmin = new UserAdmin();
});